import React, { useState, useEffect, useRef } from 'react';
import { Map, GoogleApiWrapper, Polyline, Marker, InfoWindow } from 'google-maps-react';
import { Modal } from 'react-bootstrap';
import * as moment from "moment";
import { sendData } from "../../services/auth";
import { uriList } from "../../helpers/config";
import './style.scss'


const ModalMap = (props) => {
    const [loading, setLoading] = useState(false)
    const [route, setRoute] = useState(null);
    const [locations, setLocations] = useState([]) // Locations filtradas para rota
    const [allLocations, setAllLocations] = useState([]) // Todas as locations ordenadas
    const [km, setKM] = useState(0)
    const mapRef = useRef(null);

    const selectLocations = (value) => {
        const totalLocations = value.length;

        // Se houver menos de 23 localizações, retorna todas
        if (totalLocations <= 23) {
            return value;
        }

        const result = [];

        // Adiciona a primeira localização (origem)
        result.push(value[0]);

        // Calcula o intervalo para pegar 21 pontos intermediários
        const intervalo = (totalLocations - 2) / 21;

        for (let i = 1; i <= 21; i++) {
            const index = Math.round(i * intervalo);
            if (index < totalLocations - 1) {
                result.push(value[index]);
            }
        }
        
        // Adiciona a última localização (destino)
        result.push(value[totalLocations - 1]);

        // Retorna ordenado por timestamp para manter a ordem cronológica
        return result.sort((a, b) => a.timestamp - b.timestamp);
    }

    const updateKM = async (km) => {
        await sendData({ uri: uriList("updatekm"), content: { id: props.data.id, km: km / 1000 } })
            .then((res) => {
                if (res?.status === 200) {
                   // props.onClose()
                }
            })
            .catch(error => {
                console.log(error);
            })

    }

    const resolveLocation = async (values) => {
        // Verifica se values é um array ou objeto e converte adequadamente
        let valuesArray = []
        if (Array.isArray(values)) {
            valuesArray = values
        } else if (values && typeof values === 'object') {
            valuesArray = Object.values(values)
        }
        
        // Ordena todas as locations por timestamp
        let _allLocations = valuesArray.length === 0 ? [] : valuesArray
            .filter(_item => _item.latitude && _item.longitude) // Filtra locations válidas
            .sort((a, b) => a.timestamp - b.timestamp)
            .map(_item => ({
                latitude: _item.latitude,
                longitude: _item.longitude,
                timestamp: _item.timestamp
            }))
        
        // Guarda todas as locations ordenadas para os markers de origem/destino
        setAllLocations(_allLocations)
        
        // Retorna as locations selecionadas para a rota (máx 23 pontos)
        return selectLocations(_allLocations)
    }

    const calculateTotalDistance = async (value) => {
        const directionsService = new props.google.maps.DirectionsService();
        let totalDistance = 0;

        // Divide as localizações em lotes de 23 waypoints
        const waypointsBatches = [];
        const batchSize = 23; // 23 waypoints + 1 origem + 1 destino
        for (let i = 0; i < value.length; i += batchSize) {
            waypointsBatches.push(value.slice(i, i + batchSize));
        }

        // Loop por cada lote e faz a chamada à API
        for (const waypoints of waypointsBatches) {
            const origin = waypoints[0]; // Primeiro ponto é a origem
            const destination = waypoints[waypoints.length - 1]; // Último ponto é o destino

            // Cria a lista de waypoints para a chamada à API
            const waypointsForApi = waypoints.slice(1, -1).map(loc => ({
                location: new props.google.maps.LatLng(loc.latitude, loc.longitude),
                stopover: true,
            }));

            // Chama a API do Directions
            await new Promise((resolve, reject) => {
                directionsService.route({
                    origin: new props.google.maps.LatLng(origin.latitude, origin.longitude),
                    destination: new props.google.maps.LatLng(destination.latitude, destination.longitude),
                    waypoints: waypointsForApi,
                    optimizeWaypoints: true,
                    travelMode: props.google.maps.TravelMode.DRIVING,
                }, (result, status) => {
                    if (status === props.google.maps.DirectionsStatus.OK) {
                        // Soma as distâncias de cada perna da rota
                        const km = result.routes[0].legs.reduce((kms, leg) => {
                            return kms + leg.distance.value; // valor em metros
                        }, 0);
                        totalDistance += km; // Atualiza a distância total
                        resolve(); // Resolve a Promise
                    } else {
                        console.error(`Erro ao buscar rota: ${status}`);
                        reject(status); // Rejeita a Promise
                    }
                });
            });
        }

        return totalDistance; // Retorna a distância total em metros
    };

    useEffect(() => {
        if (!props.show) return;
    
        const getData = async () => {
            setLoading(true);
            setRoute(null); // Limpa rota anterior
    
            console.log('Props locations recebidas:', props.locations)
            
            let _locations = await resolveLocation(props.locations);
            setLocations(_locations);
            
            console.log('Locations filtradas para rota:', _locations.length)
            console.log('Todas as locations (allLocations):', allLocations.length)
            
            if (_locations.length >= 2) {
                console.log('Primeira location:', _locations[0])
                console.log('Última location:', _locations[_locations.length - 1])
            }
    
            if (props.google && _locations.length >= 2) {
                const directionsService = new props.google.maps.DirectionsService();
                
                // Origem é o primeiro ponto, destino é o último
                const origin = new props.google.maps.LatLng(_locations[0].latitude, _locations[0].longitude);
                const destination = new props.google.maps.LatLng(_locations[_locations.length - 1].latitude, _locations[_locations.length - 1].longitude);
                
                // Waypoints são os pontos intermediários (sem origem e destino)
                const waypoints = _locations.slice(1, -1).map(loc => ({
                    location: new props.google.maps.LatLng(loc.latitude, loc.longitude),
                    stopover: false, // stopover false para não parar em cada ponto
                }));
                
                console.log('Chamando Directions API com', waypoints.length, 'waypoints')
    
                directionsService.route({
                    origin,
                    destination,
                    waypoints: waypoints.length > 0 ? waypoints : undefined,
                    optimizeWaypoints: false, // Mantém a ordem cronológica
                    travelMode: props.google.maps.TravelMode.DRIVING,
                }, (result, status) => {
                    if (status === props.google.maps.DirectionsStatus.OK) {
                        setRoute(result);
                        console.log('Rota calculada com sucesso')
                    } else {
                        console.error(`Erro ao buscar rota: ${status}`);
                    }
                    setLoading(false);
                });
            } else {
                setLoading(false);
            }
        };
    
        getData();
    }, [props.show, props.locations]); // Adiciona props.locations como dependência
    


    const onMapReady = (mapProps, map) => {
        // Ajustar para o mapa "maximizado"
        const bounds = new props.google.maps.LatLngBounds();

        // Usa allLocations para ajustar o zoom do mapa
        allLocations.forEach(_item => {
            bounds.extend({ lat: _item.latitude, lng: _item.longitude });
        })

        if (allLocations.length > 0) {
            map.fitBounds(bounds);
        }
    };

    const MapContent = () => {
        // Usa allLocations para os markers (primeiro e último ponto real)
        const hasLocations = allLocations.length > 0;
        
        if (loading) {
            return (
                <div style={{ width: '100%', height: '600px', display:"flex", justifyContent:"center", alignItems:"center"}}>
                    <i className='fa fa-spin fa-spinner' style={{fontSize:"40px"}}/>
                </div>
            )
        }
        
        if (!hasLocations) {
            return (
                <div className='bg-warning' style={{ padding: "10px", borderRadius: "5px", display: "flex", justifyContent: "center" }}>
                    <span>Nenhuma localização foi capturada!</span>
                </div>
            )
        }
        
        // Ícones diferentes para origem e destino
        const iconOrigem = {
            url: "https://maps.google.com/mapfiles/ms/icons/green-dot.png",
            scaledSize: new props.google.maps.Size(35, 35),
        };
        const iconDestino = {
            url: "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
            scaledSize: new props.google.maps.Size(35, 35),
        };
        
        // Primeiro e último ponto das locations ORIGINAIS (não filtradas)
        const origem = allLocations[0];
        const destino = allLocations[allLocations.length - 1];
        
        return (
            <div style={{ width: '100%', height: '100%', display: "flex", gap: 5 }}>
                <div>
                    <Map
                        ref={mapRef}
                        google={props.google}
                        onReady={onMapReady}
                        style={{ width: '800px', height: '600px' }}
                    >
                        {/* Marker de ORIGEM (verde) - primeiro ponto cronológico */}
                        <Marker
                            position={{ lat: origem.latitude, lng: origem.longitude }}
                            title={`INÍCIO (${origem.latitude}, ${origem.longitude}) | Data: ${moment(origem.timestamp).format('DD/MM/YYYY HH:mm:ss')}`}
                            icon={iconOrigem}
                        />

                        {/* Marker de DESTINO (vermelho) - último ponto cronológico */}
                        <Marker
                            position={{ lat: destino.latitude, lng: destino.longitude }}
                            title={`FIM (${destino.latitude}, ${destino.longitude}) | Data: ${moment(destino.timestamp).format('DD/MM/YYYY HH:mm:ss')}`}
                            icon={iconDestino}
                        />

                        {/* Polyline da rota */}
                        {route && route.routes && route.routes[0] && (
                            <Polyline
                                path={route.routes[0].overview_path}
                                strokeColor="#006400"
                                strokeOpacity={0.9}
                                strokeWeight={5}
                            />
                        )}
                    </Map>
                </div>
            </div>
        )
    }

    return (
        <>
            <Modal
                show={props.show}
                size="lg"
                // fullscreen={true}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                onHide={() => props.onClose()} >
                {/* <Modal.Header closeButton className="modal-header-padding-0" > */}
                <div style={{ display: "flex", justifyContent: "space-between", marginLeft: "5px" }}>
                    <Modal.Title id="contained-modal-title-vcenter" >
                        <i className="fa fa-map-location-dot" style={{ fontSize: "14px" }} /> <span style={{ fontSize: "14px" }}>Rota de Atendimento: </span> <span style={{ fontSize: "18px", marginLeft: "15px" }}>{props?.data?.client + ' - ' +
                            moment(props?.data?.startDate || props?.data?.startdate).format('DD/MM/YYYY') + ' - ' + (props?.data?.userName || props?.data?.username)?.split(" ").slice(0, 2).join(" ")}</span>
                        <span> | Distância: {km < 1000 ? km : (km / 1000).toFixed(2)} {km < 1000 ? "Mts" : "KM"}</span>
                    </Modal.Title>
                    <i className="fa fa-close" style={{ fontSize: "14px", marginRight: "5px", marginTop: "5px", cursor: "pointer" }} onClick={() => props.onClose()} />
                </div>
                {/* </Modal.Header> */}
                <Modal.Body style={{ width: "800px", height: "600px", padding: "0px" }}>
                    <div style={{ display: "flex", gap:"10px" }}>
                        
                        <div style={{width:"100%"}}>
                            <MapContent />
                        </div>

                    </div>

                </Modal.Body>
            </Modal>
        </>
    );
};

console.log(process.env.REACT_APP_API_GOOGLE_MAPS)
export default GoogleApiWrapper({
    apiKey: process.env.REACT_APP_API_GOOGLE_MAPS
})(ModalMap);
